import { IPhoneChangeViewModel } from '../types/phoneChangeViewModel'

export class PhoneChangeViewModel implements IPhoneChangeViewModel
{
    homePhone: string = ''
    businessPhone: string = ''
    mobilePhone: string = ''
    leaseNumber: string = ''
    isActiveLease: boolean = false
    hasExistingPhoneChangeRequest: boolean = false
    existingPhoneChangeRequestId: string = ''
    referenceNumber: string = ''
}